// Flow Storage Utility
import { DataFlow } from "./models/data-integration.model";

const STORAGE_KEY = "data-integration-flows";

export class FlowStorage {
  // Get all flows from localStorage or return empty array if none exist
  static getFlows(): DataFlow[] {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
      // Return empty array if no stored data exists
      return [];
    } catch (error) {
      console.error("Error reading flows from storage:", error);
      return [];
    }
  }

  // Save all flows to localStorage
  static setFlows(flows: DataFlow[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(flows));
    } catch (error) {
      console.error("Error saving flows to storage:", error);
    }
  }

  // Add a new flow
  static addFlow(flow: DataFlow): void {
    const flows = this.getFlows();
    flows.push(flow);
    this.setFlows(flows);
  }

  // Update an existing flow
  static updateFlow(updatedFlow: DataFlow): void {
    const flows = this.getFlows();
    const index = flows.findIndex((f) => f.id === updatedFlow.id);
    if (index !== -1) {
      flows[index] = updatedFlow;
      this.setFlows(flows);
    }
  }

  // Delete a flow
  static deleteFlow(flowId: string): void {
    const flows = this.getFlows();
    const filteredFlows = flows.filter((f) => f.id !== flowId);
    this.setFlows(filteredFlows);
  }

  // Get a specific flow by ID
  static getFlow(flowId: string): DataFlow | undefined {
    const flows = this.getFlows();
    return flows.find((f) => f.id === flowId);
  }

  // Clear all flows
  static clearFlows(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
